import { onMounted, ref } from "vue";

// Overlay HTML is not emitted into <body> by our SSR renderer. Keep its
// Teleport absent during hydration so Vue cannot adopt unrelated body nodes
// (including #app). Mount it normally after its owning component hydrates.
export function useClientMounted() {
  const mounted = ref(false);
  onMounted(() => {
    mounted.value = true;
  });
  return mounted;
}
